import { API } from "../store"
import handleCatch from "../lib/catch"
import serialize from "../store/serialize"
import { setUserRating } from "./users"
import { setCrewRating } from "./crew"
import { setActiveChatterRating } from "./message-drawer"
import AwesomeDebouncePromise from "awesome-debounce-promise"

const asyncFunctionDebounced = AwesomeDebouncePromise(asyncFunction, 500)
const asyncFunction = () => API

export const setData = (property = "", data = true) => ({
  type: "MISC::DATA::SET",
  property,
  data,
})

export const pushData = (property = "", data = true) => ({
  type: "MISC::DATA::PUSH",
  property,
  data,
})

const callAPI = (API, route) => API.get(route)
const debounceCalls = AwesomeDebouncePromise(callAPI, 500)

export const getUsersByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/users/filter/full_name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("users", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const getRolesByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/roles/filter/name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("roles", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const getCompaniesByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/client_companies/filter/name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("companies", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getClientsByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/clients/filter/name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("clients", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getLocationByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/locations/filter/city/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("locations", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const getShootsByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/shoots/filter/name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            // if (!response.ok) {
            //   throw Error(response.statusText)
            // }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("shoots", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getEquipmentByInput = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var route = `/generic/equipment/filter/name/${id}`
        const result = debounceCalls(API, route)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("equipment", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const _setRating = (...args) => {
  return dispatch => {
    dispatch(setUserRating(...args))
    dispatch(setCrewRating(...args))
    dispatch(setActiveChatterRating(...args))
  }
}

export const getUsers = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/generic/users/filter/full_name`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("users", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getRoles = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/generic/roles/filter/name`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("roles", data.data))
            dispatch(setData("allRoles", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getRolesView = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/generic/roles/filter/name`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("roles", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getLocations = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/generic/locations/filter/city/`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            serialize("location", data.data).then(response => {
              dispatch(setData("locations", response))
              resolve(response)
            })
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createLocation = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/locations${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "locations created") {
              dispatch(
                pushData("locations", {
                  ...data,
                  id: response.id,
                })
              )
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateLocation = (data, locationId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(
          `/generic/locations/${locationId}${userId ? "/user/" + userId : ""}`
        )
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "locations updated") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeLocation = (locationId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/locations/${locationId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "locations deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createRole = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/roles${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "roles created") {
              dispatch(
                pushData("roles", {
                  ...data,
                  id: response.id,
                })
              )
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateRole = (data, roleId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/roles/${roleId}${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "roles updated") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeRole = (roleId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/generic/roles/${roleId}${userId ? "/user/" + userId : ""}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "roles deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const getEquipment = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/generic/equipment/filter/name`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("equipment", data.data))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createEquipment = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/equipment${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "equipment created") {
              dispatch(
                pushData("equipment", {
                  ...data,
                  id: response.id,
                })
              )
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateEquipment = (data, equipmentId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(
          `/generic/equipment/${equipmentId}${userId ? "/user/" + userId : ""}`
        )
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "equipment updated") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeEquipment = (equipmentId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/equipment/${equipmentId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "equipment deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createNote = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/notes${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "notes created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeNote = (noteId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/generic/notes/${noteId}${userId ? "/user/" + userId : ""}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "notes deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const updateNote = (data, noteId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/notes/${noteId}${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "notes updated") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createVehicle = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/vehicles${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "vehicles created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeVehicle = (vehicleId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/vehicles/${vehicleId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "vehicles deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateVehicle = (data, vehicleId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(
          `/generic/vehicles/${vehicleId}${userId ? "/user/" + userId : ""}`
        )
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "vehicles updated") {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const uploadFile = (file, folderName) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        var formData = new FormData()
        formData.append("file", file)
        formData.append("folder", folderName)
        formData.append(
          "upload_preset",
          process.env.REACT_APP_CLOUDINARY_UNSIGNED_UPLOAD
        )
        fetch(
          `https://api.cloudinary.com/v1_1/${
            process.env.REACT_APP_CLOUDINARY_CLOUD_NAME
          }/upload`,
          {
            method: "post",
            body: formData,
          }
        )
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              response.json().then(data => {
                delete data.original_filename
                resolve(data)
              })
            } else {
              reject(response)
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createPhone = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/phones${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "phones created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createEmail = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/emails${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "emails created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removePhone = (phoneId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/phones/${phoneId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "phones deleted") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeEmail = (emailId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/emails/${emailId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "emails deleted") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createWebsite = (data, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/generic/websites${userId ? "/user/" + userId : ""}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "websites created") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const removeWebsite = (websiteId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/generic/websites/${websiteId}${userId ? "/user/" + userId : ""}`
        )
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "websites deleted") {
              resolve(response)
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const addRating = (score, ratingId, userId, loggedInUser, companyId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(
          `/generic/ratings${ratingId ? "/" + ratingId : ""}${
            userId ? "/user/" + userId : ""
          }`
        )
          .send({
            score,
          })
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "ratings created") {
              resolve()
              let rating = {
                score,
                company_id: companyId || 0,
                creator_id: loggedInUser.id,
                creator_first_name: loggedInUser.first_name,
                creator_last_name: loggedInUser.last_name,
                creator_profile_image: loggedInUser.profile_image,
              }
              if (ratingId) {
                rating.id = ratingId
                rating.newId = response.data.id
              } else {
                rating.newId = response.data.id
              }
              dispatch(_setRating(userId, rating, response.avg_rating))
            } else {
              reject()
            }
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createBadge = userId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.get(`/generic/badges/1/user/${userId}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "badges added to user") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const deleteBadge = userId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.delete(`/generic/badges/1/user/${userId}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "badges deleted") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const getAds = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      API.get("/ads")
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          return response
        })
        .then(res => res.body)
        .then(res => {
          if (res.ads) {
            resolve(res.ads)
          } else {
            reject(res)
          }
        })
    })
  }
}

export const getSocialNetworks = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/social-networks`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }
            return response
          })
          .then(response => response.body)
          .then(data => {
            dispatch(setData("networks", data.networks))
            resolve(data)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const socialConnect = (id, data) => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/social/twitter-auth/${id}`)
      .send(data)
      .then(response => {
        window.location = response.body.redirect
        resolve(response)
      })
      .catch(error => reject(error))
  })
  return deferred
}

export const publishPost = (id, data) => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/posts/publish/${id}`)
      .send(data)
      .then(result => {
        resolve(result.text)
      })
      .catch(error => {
        reject(error)
      })
  })
  return deferred
}

export const publishPostByCompany = (id, data) => dispatch => {
  const deferred = new Promise((resolve, reject) => {
    API.post(`/posts/publish-company/${id}`)
      .send(data)
      .then(result => {
        resolve(result.text)
      })
      .catch(error => {
        reject(error)
      })
  })
  return deferred
}

export const checkSocialTokens = () => dispatch => {
  return new Promise((resolve, reject) => {
    API.get("/social/verify")
      .then(response => {
        resolve(response.body)
      })
      .catch(error => reject(error))
  })
}
